/** On screen for everything but `idle` and `hidden`. */
export const SEARCH_ANSWER_STATUS = {
  IDLE: 'idle',
  /** Panda declined this search (`show_chat: false`, or it finished with no answer), for good. */
  HIDDEN: 'hidden',
  LOADING: 'loading',
  STREAMING: 'streaming',
  DONE: 'done',
  SUGGESTION: 'suggestion',
  /** Failed or stalled. */
  ERROR: 'error',
} as const;

export type SearchAnswerStatus = (typeof SEARCH_ANSWER_STATUS)[keyof typeof SEARCH_ANSWER_STATUS];

/**
 * A dead connection often stalls silently instead of erroring, so the silence is
 * bounded. Matches the chat's RUN_STALL_TIMEOUT_MS.
 */
export const STALL_TIMEOUT_MS = 40_000;
